<script>import {} from "../util/svg-util.js";
import { getTag } from "../../dsp/signal/helpers/to-path.js";
import { CubicBezier } from "../../d3-mapp/curve/index.js";
export let tag = "";
export let defaultStroke;
export let strokes;
export let paths;
export let xScale = (v) => v.getTime ? v.getTime() : v;
export let yScale = (v) => v;
const getStroke = (index, tag2) => strokes[tag2].stroke[index % strokes[tag2].stroke.length];
</script>

<g
  class="graph {tag}"
  fill="none"
  stroke={defaultStroke?.color.formatHex()}
  stroke-opacity={defaultStroke?.color.opacity}
  stroke-width={defaultStroke?.width}
  stroke-dasharray={defaultStroke?.dash?.join(" ")}
>
  {#each paths as path, index}
    {#each path as pathSection}
      {#if pathSection.section.length > 0}
        <path
          class={getTag(pathSection)}
          stroke={getStroke(index, getTag(pathSection)).color.formatHex()}
          stroke-opacity={getStroke(index, getTag(pathSection)).color.opacity}
          stroke-width={getStroke(index, getTag(pathSection)).width}
          stroke-dasharray={getStroke(index, getTag(pathSection)).dash?.join(
            " ",
          )}
          d={CubicBezier.path(pathSection.section, xScale, yScale)}
        />
      {/if}
    {/each}
  {/each}
</g>
